<script>
  export let image;
</script>

<div class="h-screen">
  <img src={image.src} alt={image.alt} class="h-full w-full object-cover object-center"/>
</div>